import React, { useState, useEffect, useRef } from "react";
import "./chart_contentChemical.css";
import bottleImage from "../../../../../assets/conserve-chemical-chart-01-image-01.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = '73%';
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="conserve-chemical-chart-01-section" ref={chartSectionRef}>
      <div className="conserve-chemical-chart-01-container">
        <div className="conserve-chemical-chart-01-container-content-02">
          <img className="conserve-chemical-chart-01-image" src={bottleImage} alt="Bottle" />
          <div className="conserve-chemical-chart-01-image-water-effect-02" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Chart;
